import LinkSVG from '@components/icons/linkIcon.svg';
import LinkMobileSVG from '@components/icons/linkIconDark.svg';
import styled from 'styled-components';

export const LinkText = styled.p`
  color: #474747;
  font-size: ${({ theme }) => theme.typography.paragraph.fontSize.medium.mobile};
  font-weight: ${({ theme }) => theme.typography.paragraph.fontWeight.subtitle};
  font-family: ${({ theme }) => theme.typography.paragraph.fontFamily.default};
`;

export const LinkIcon = styled(LinkSVG)`
  flex-shrink: 0;
  margin-right: 0.5rem;
`;

export const LinkMobileIcon = styled(LinkMobileSVG)<{ color?: string }>`
  flex-shrink: 0;
  & .hover {
    transition: 0.2s ease-in-out;
  }

  &:hover .hover {
    fill: ${({ color }) => color};
  }
`;
